import React from 'react';

import crypto from 'crypto'

const decodeParams = function(encrypted) {

  const secret = "dogCAT12301$"

  const iv = "3f9054bae77d5a5e" //using a constant to decrypt

  const key = secret.padStart(32);

  let decryptedMsg = encrypted

  try {

      const decrypter = crypto.createDecipheriv("aes-256-cbc", key, iv);

      decryptedMsg = decrypter.update(encrypted, "hex", "utf8");

      decryptedMsg += decrypter.final("utf8");

  }  catch(e) {

      console.log('Non encrypted data will pass through decryption but errors are trappled and handled');
  }

  return decryptedMsg

}


export default decodeParams;




// WEBPACK FOOTER //
// ./src/components/utilities/decodeParams.js